import Vue from "vue";
import vuelidate from "vuelidate";
// @ts-ignore
import vuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";

Vue.use(vuelidate);
Vue.use(vuelidateErrorExtractor, { templates, i18n: "validation" });
